<template>
  <div class="no-result-index">
    <div class="title">{{title}}</div>
    <div class="text"
      @click="toCityList">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'no-result-index',
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '去其他城市看看吧~'
    }
  },
  mounted () {},

  methods: {
    toCityList () {
      this.$emit('toCityList')
      // this.$router.push('/city-list');
    }
  }
}
</script>

<style lang="less" scoped>
// @import "../assets/css/variable";
@image: "../assets/images/";
.theme-ccb {
  .no-result-index {
    .text {
      color: @color-ccb-theme;
    }
  }
}
.no-result-index {
  line-height: 38/200rem;
  padding: 60/200rem 0;
  background-color: #fff;
  text-align: center;
  color: #999;
  .text {
    padding-top: 10/200rem;
    font-size: 28/200rem;
    color: @color-theme;
    text-decoration: underline;
  }
  .title {
    font-size: 28/200rem;
  }
  &.font36 {
    .text,
    .title {
      font-size: 36/200rem;
      line-height: 50/200rem;
    }
  }
}
</style>
